module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/weasel.7a358037.png";